// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__3nfxh","overflowing":"ReadFullNote_overflowing__11Cfj"};